import pathToRegexp from 'path-to-regexp'
import { useEffect } from 'react'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import { useSetState } from 'ahooks'
import { useLocation } from 'react-router-dom'
import { dfs } from 'shj-utils'
import useWorkshopStore from '@/store/workshop.ts'
import { triggerEvent } from '@/utils/customEvent.ts'

export default function useMenuSelection() {
  const location = useLocation()

  const [state, setState]: any = useSetState({
    selectedMenuKey: '',
    selectedGlobalMenuItem: null,
  })

  const { globalMenu } = useGlobalStore(
    useShallow((state: any) => ({
      globalMenu: state.menu,
    }))
  )

  const findAppMenu = () => {
    let appCode = ''
    let rootNode: any = null
    let key = ''
    let item: any = null
    // 找到 url 对应的 资源系统
    dfs(globalMenu, d => {
      if (!appCode && d.level === 0) {
        rootNode = d
      }

      if (d.path) {
        const matchList = [
          pathToRegexp(d.path.replace(/^\$\//g, '/')),
          pathToRegexp(d.path + '/details/:id'),
          pathToRegexp(d.path + '/detail/:id'),
        ]

        const microPath = location.pathname.replace(d.apppath, '')
        const mainPath = location.pathname
        if (
          !appCode &&
          matchList.find(matchItem => matchItem.exec(mainPath) || matchItem.exec(microPath))
        ) {
          // selectedGlobalMenuItem = d

          if (rootNode) {
            appCode = rootNode?.code
            item = rootNode
          }
          return true
        }
      }
    })

    // 找到 code 对应的 菜单
    const app = globalMenu.find((d: any) => d.code === appCode)
    key = app?.key || app?.code
    return [key, item]
  }

  useEffect(() => {
    let selectedMenuKey = ''
    let selectedGlobalMenuItem = null

    if (
      pathToRegexp('/main/*').test(location.pathname) ||
      pathToRegexp('/main').test(location.pathname)
    ) {
      /** 主应用 **/
      selectedMenuKey = location.pathname
      const [key, item] = findAppMenu()
      if (item) {
        selectedGlobalMenuItem = item
        selectedMenuKey = item.key
      }
    } else if (pathToRegexp('/flow/*').test(location.pathname)) {
      /** 工单 **/
      selectedMenuKey = location.pathname + location.search
    } else if (pathToRegexp('/upms/*').test(location.pathname)) {
      /** 管理员设置 **/
      selectedMenuKey = 'upms'
      selectedGlobalMenuItem = globalMenu.find(item => item.code === 'enterpriseBackground')
    } else if (pathToRegexp('/config/*').test(location.pathname)) {
      /** 管理员设置 **/
      selectedMenuKey = 'config'
      selectedGlobalMenuItem = globalMenu.find(item => item.code === 'BusinessPlus')
    } else {
      /** 其他菜单 **/
      const [key, item] = findAppMenu()
      if (key) selectedMenuKey = key
      if (item) selectedGlobalMenuItem = item
    }

    if (selectedMenuKey || selectedGlobalMenuItem) {
      setState({
        selectedMenuKey,
        selectedGlobalMenuItem,
      })
    }
    // console.log('globalMenu', globalMenu)
    if (globalMenu.length) {
      triggerEvent('MENU_ON_LOAD', { selectedGlobalMenuItem })
    }

    // console.log(location.pathname + location.search)
  }, [location.pathname, globalMenu])

  return [state.selectedMenuKey, state.selectedGlobalMenuItem]
}
